import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u355215173/domains/save-lifes.org/hbuilds/source/repository/src/app/sign-up-login-screen/components/AuthForm.tsx");
